import { gql } from '@apollo/client'

export const SHOP_GIFT_CARD_VARIANT_FRAGMENT = gql`
  fragment ShopGiftCardVariant on ShopGiftCardVariant {
    id
    name
    price
    priceFormatted
  }
`
